module.exports = __webpack_public_path__ + "img/des-4.9c52e46f.png";